import React, { useEffect, useState } from "react";
import {
  AzureAD,
  AuthenticationState,
  IAzureADFunctionProps,
} from "react-aad-msal";
import { AuthProvider } from "./../../AuthProvider";
import { store } from "../../.";
import { accountApi } from "../../api/accountApi";
import { NominationApi } from "../../api/nominationApi";
import { DefaultButton, Persona, PersonaSize, Dialog, DialogType, DialogFooter, PrimaryButton } from "@fluentui/react";
import { graphApi } from "../../api/graphApi";
import { Image } from "@fluentui/react";
import { toast } from "react-toastify";
import ToastContent from "./ToastContent";

const SignOutPage: React.FC = () => {
  const [profilePic, setProfilePic] = useState("");
    const [userGroups, setUserGroups] = useState("");
    const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    async function getProfilePic() {
      await accountApi.validateToken();

      try {
        const image = await graphApi.getPhoto();
        const profilePic = Buffer.from(image.data, "binary").toString("base64");

        setProfilePic(profilePic);
      } catch {
        console.log("error getting image");
      }

      const userGroups = await accountApi.getUserGroupsAsync();

      setUserGroups(userGroups);
    }

    getProfilePic();
  }, []);

    const resetData = async () => {
        let success = false;
        try {
            success = await NominationApi.resetData();
        } catch (ex) {

        } finally {
            setShowConfirmModal(false)
        }


        toast.info(
            <ToastContent
                title={success ? "Data successfully reset." : "Unable to reset data."}
                content={success ? `Please hard refresh the website to reflect new changes.` : 'Please contact support.'}
                buttons={[{ text: "Dismiss", action: () => toast.dismiss() }]}
            />,
            {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        );
    }

  return (
    <div>
      <AzureAD provider={AuthProvider} reduxStore={store.store}>
        {(a: IAzureADFunctionProps) => {
          if (a.authenticationState === AuthenticationState.Authenticated) {
            return (
              <div
                className="ms-Grid-row"
                style={{
                  paddingLeft: "25%",
                  paddingRight: "25%",
                  paddingTop: "50px",
                }}
              >
                <div className="ms-Grid-col ms-sm12">
                  <div className="signOutHeader">My Account</div>
                  <div style={{ paddingTop: "30px" }}>
                    <span
                      style={{
                        float: "left",
                        paddingRight: "20px",
                        width: "90px",
                      }}
                    >
                      {profilePic && (
                        <Image
                          style={{
                            borderRadius: "50%",
                            height: "auto",
                          }}
                          src={`data:image/jpeg;base64, ${profilePic}`}
                          width="70"
                          height="70"
                        />
                      )}
                      {!profilePic && (
                        <Persona
                          size={PersonaSize.size72}
                          initialsColor={"var(--primary-500)"}
                          color={"var(--primary-500)"}
                          imageInitials={a
                            .accountInfo!.account.name.split(" (")[0].split(" ")
                            .map((n, i, a) =>
                              i === 0 || i + 1 === a.length ? n[0] : null
                            )
                            .join("")}
                        />
                      )}
                    </span>
                    <span>
                      <b>{a.accountInfo && a.accountInfo.account.name}</b>{" "}
                      <br></br>{" "}
                      {a.accountInfo && a.accountInfo.account.userName}
                      <br></br> {userGroups}
                    </span>
                    <span style={{ float: "right" }}>
                      <DefaultButton text="SIGN OUT" onClick={a.logout} />
                    </span>
                  </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <DefaultButton
                            text="Reset All Data"
                            sizes="large"
                            onClick={() => setShowConfirmModal(true)}
                            style={{ alignSelf: 'center', width: '100%', marginTop: 30 } }
                            styles={{
                                root: {
                                    backgroundColor: '#dc3545',
                                    borderColor: '#dc3545',
                                    color: '#fff',
                                    height: 48,
                                    fontSize: 24
                                }
                            }}
                        />
                    </div>
              </div>
            );
          } else {
            return (
              <div style={{ float: "right", display: "inline-block" }}>
                <button onClick={a.login}>Login</button>
              </div>
            );
          }
        }}
          </AzureAD>

          <Dialog
              hidden={!showConfirmModal}
              dialogContentProps={{
                  type: DialogType.normal,
                  title: "Reset Data",
                  subText: "Are you sure you want to reset the data?",
              }}
              styles={{ main: { width: 350 } }}
              onDismiss={() => setShowConfirmModal(false)}
          >
              <DialogFooter>
                  <PrimaryButton
                      onClick={() => resetData()}
                      text="Confirm"
                  />
                  <DefaultButton
                      onClick={() => setShowConfirmModal(false)}
                      text="Cancel"
                  />
              </DialogFooter>
          </Dialog>
    </div>
  );
};

export default SignOutPage;